import fetch from "auth/FetchInterceptor";

const youtubeService = {};

/**
 * Valida um vídeo do YouTube
 * Retorna metadados incluindo duração
 * @param {string} url - URL do vídeo do YouTube
 * @returns {Promise<{available: boolean, title?: string, duration?: number, durationFormatted?: string, errorType?: string, errorMessage?: string}>}
 */
youtubeService.validate = async function (url, maxDurationSeconds) {
	return fetch({
		url: "/v1/rpc/youtube/validate",
		method: "post",
		data: maxDurationSeconds ? { url, maxDurationSeconds } : { url },
	});
};

export default youtubeService;
